import PropTypes, { bool, string, node } from 'prop-types';

export const sso = PropTypes.shape({
  login: PropTypes.shape({
    href: PropTypes.string.isRequired
  }).isRequired
});

export const link = PropTypes.shape({
  href: string,
  title: string
});

export const eids = PropTypes.shape({
  click: string,
  impression: string
});

export const messages = PropTypes.shape({
  closeText: node.isRequired,
  noNotificationsTitle: node.isRequired,
  noNotificationsText: node.isRequired,
  headerText: node.isRequired,
  failedNotificationsTitle: node.isRequired,
  failedNotificationsText: node.isRequired,
  failedNotificationsLink: node.isRequired
});

export const notification = PropTypes.shape({
  title: string.isRequired,
  content: string.isRequired,
  link: string,
  priority: string,
  subcategory: string,
  eids: eids,
  viewed: bool
});

const shapes = {
  sso,
  link,
  eids,
  messages,
  notification
};

export { shapes as default };
